query GetRelatedCaseRecords($caseRecordId: ID!) {
  relatedCaseRecords(caseRecordId: $caseRecordId) {
    id
    caseType
    relatedCase {
      id
      description
      caseNumber
    }
  }
}
